import { ErrorNavItem } from '../../shared/components/error-nav/error-nav.models';
import { FeeWorksheetMilestone, GetCcwSectionName } from './ccw.enums';

export const ErrorLinkNavigateToUrla = 'ErrorLinkNavigateToUrla';
export const LoanPropertyRequiredErrors: ErrorNavItem[] = [
  // Loan
  {
    controlId: 'loanpurposedesc',
    controlName: 'Other Purpose Description',
    errorText: 'Please enter the Other Purpose Description. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'mortgagetype',
    controlName: 'Mortgage Type',
    errorText: 'Please select the Mortgage Type. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'amortizationtype',
    controlName: 'Amortization Type',
    errorText: 'Please select the Amortization Type. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'loanPurpose',
    controlName: 'Purpose of Loan',
    errorText: 'Please select the Purpose of Loan. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'loanprogramcode',
    controlName: 'Loan Program Code',
    errorText: 'Please select the Loan Program Code. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'loanprogramname',
    controlName: 'Loan Program Name',
    errorText: 'Please select the Loan Program Name. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'typeOfRefi',
    controlName: 'Refinance Type',
    errorText: 'Please select the Type of Refinance. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'currentunpaidamount',
    controlName: 'Current Unpaid Principal',
    errorText: 'Please enter the Current Unpaid Principal Balance Amount. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'existinglien',
    controlName: 'Existing Lien',
    errorText: 'Please select the Existing 2nd Lien. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  { controlId: 'pmitype', controlName: 'PMI Type', errorText: 'Please select the PMI Type', errorLink: null },
  {
    controlId: 'veteranHasDisability',
    controlName: 'Veteran Has Disability',
    errorText: 'Please answer "Are you classified as a disabled veteran?". Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'sectionofact',
    controlName: 'Section of Act',
    errorText: 'Please select the Section Of Act. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'everhadvaloan',
    controlName: 'Ever Had VA Loan',
    errorText: 'Please answer "Have you ever owned a home financed through VA?". Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'fundingfeetype',
    controlName: 'Funding Fee Type',
    errorText: 'Please select the Funding Fee Type. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'salesPrice',
    controlName: 'Sales Price',
    errorText: 'Closing Corp requires Sales Price have a value equal or greater than $1.00',
    errorLink: null,
  },
  { controlId: 'appraisalValue', controlName: 'Appraisal Value', errorText: 'Please provide the Appraised Value', errorLink: null },
  { controlId: 'baseLoanAmount', controlName: 'Base Loan Amount', errorText: 'Please provide the Base Loan Amount', errorLink: null },
  { controlId: 'totalLoanAmount', controlName: 'Note Loan Amount', errorText: 'Please provide the Note Loan Amount', errorLink: null },
  {
    controlId: 'subfibaseloan',
    controlName: 'Subordinate Amount',
    errorText: 'Please enter the Subordinate Amount',
    errorLink: ErrorLinkNavigateToUrla,
  },
  { controlId: 'interestRate', controlName: 'Interest Rate', errorText: 'Please enter the Interest Rate', errorLink: null },
  { controlId: 'fileCreditScore', controlName: 'FICO Score', errorText: 'Please enter a FICO Score between 300 - 850', errorLink: null },
  {
    controlId: 'fhaassigndate',
    controlName: 'FHA Case Assignment Date',
    errorText: 'Please select the FHA Case Assignment Date',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'validfhaassigndate',
    controlName: 'FHA Case Assignment Date',
    errorText: 'Please enter or select a valid FHA case assignment date',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'usdaassigndate',
    controlName: 'USDA Case Assignment Date',
    errorText: 'Please select the USDA Case Assignment Date',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'validusdaassigndate',
    controlName: 'USDA Case Assignment Date',
    errorText: 'Please enter or select a valid USDA case assignment date',
    errorLink: ErrorLinkNavigateToUrla,
  },

  // Property
  {
    controlId: 'propertyaddress',
    controlName: 'Subject Property Address',
    errorText: 'Please enter the Subject Property Address or mark the check box to copy from Borrowers Current Address. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'propertyType',
    controlName: 'Property Type',
    errorText: 'Please enter the Property Type. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'street',
    controlName: 'Street Address',
    errorText: 'Please enter the Street Address (note Address cannot be TBD for Refinance). Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  { controlId: 'city', controlName: 'City', errorText: 'Please enter the City Name. Go to URLA.', errorLink: ErrorLinkNavigateToUrla },
  { controlId: 'state', controlName: 'State', errorText: 'Please provide the State. Go to URLA.', errorLink: ErrorLinkNavigateToUrla },
  { controlId: 'zip', controlName: 'Zip', errorText: 'Please enter the Zip Code. Go to URLA.', errorLink: ErrorLinkNavigateToUrla },
  { controlId: 'county', controlName: 'County', errorText: 'Please provide the County. Go to URLA.', errorLink: ErrorLinkNavigateToUrla },
  {
    controlId: 'occupancy',
    controlName: 'Occupancy Type',
    errorText: 'Please select the Occupancy Type. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'typeofproperty',
    controlName: 'Type of Property',
    errorText: 'Please select the Property Type. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'numberOfUnits',
    controlName: 'Number of Units',
    errorText: 'Please provide the Number Of Units (1 - 4). Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  { controlId: 'sizeInAcres', controlName: 'Size (In Acres)', errorText: 'Please input the Size', errorLink: null },
  { controlId: 'loCommunicationToDisclosuresAmcValue', controlName: 'AMC', errorText: 'Please select the AMC provider', errorLink: null },
  {
    controlId: 'township',
    controlName: 'Township',
    errorText: 'Please enter a valid value for Township. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'currentlender',
    controlName: 'Current Lender',
    errorText: 'Please enter current lender value. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'originalprinciple',
    controlName: 'Original Principal of Current Loan',
    errorText: 'Please enter Original Principal of Current Loan value. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'monthoryearcurrentloan',
    controlName: 'Month/Year current loan was taken',
    errorText: 'Please enter the value for Month/Year current loan was taken. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'yearcurrentyproperty',
    controlName: 'Year current property was purchased',
    errorText: 'Please enter the value for Year current property was purchased. Go to URLA.',
    errorLink: ErrorLinkNavigateToUrla,
  },
  {
    controlId: 'jumboRequiredSecondAppraisal',
    controlName: 'Jumbo Required',
    errorText: 'Please select the Jumbo Require a second Appraisal?',
    errorLink: null,
  },
  {
    controlId: 'isLoanANewConstruction',
    controlName: 'New Construction',
    errorText: 'Please select the New Construction',
    errorLink: null,
  },
  {
    controlId: 'rushAppraisal',
    controlName: 'Rush Appraisal?',
    errorText: 'Please select Rush Appraisal',
    errorLink: null,
  },
  {
    controlId: 'finalOrReinspection1004dRequired',
    controlName: 'Final or Re-inspection 1004D required?',
    errorText: 'Please select Final or Re-inspection 1004D required',
    errorLink: null,
  },
  {
    controlId: 'appraisalWaiver',
    controlName: 'Appraisal Waiver',
    errorText: 'Appraisal Waiver must be selected if selected AMC is "PIW-No Appraisal Fee."',
    errorLink: null,
  },

  // Important Dates
  {
    controlId: 'loanEstimatedClosingDate',
    controlName: 'Estimated Closing Date',
    errorText: 'Please select / enter the Estimated Closing Date greater or equal to todays date',
    errorLink: null,
  },
  {
    controlId: 'estimatedFundingDate',
    controlName: 'Estimated Funding Date',
    errorText: 'Please select / enter the Estimated Funding Date greater or equal to todays date',
    errorLink: null,
  },
  {
    controlId: 'loanFirstPaymentDate',
    controlName: 'First Payment Date',
    errorText: 'Please select / enter the First Payment Date greater or equal to todays date',
    errorLink: null,
  },
  {
    controlId: 'validestimatedClosingDate',
    controlName: 'Estimated Closing Date',
    errorText: 'Please select / enter the Estimated Closing Date greater or equal to todays date',
    errorLink: null,
  },
  { controlId: 'daysOfPerDiem', controlName: '# of Days of Per Diem', errorText: '# of Days of Per Diem cannot exceed 32', errorLink: null },
  { controlId: 'floodZone', controlName: 'Flood Zone', errorText: 'Please select if the property in the Flood Zone', errorLink: null },
];

export const SurveyRequiredErrors: ErrorNavItem[] = [
  {
    controlId: 'landServiceControlId',
    controlName: 'Land Service Provider',
    errorText: 'Land Survey Co. is required. Please make a selection before continuing.',
    errorLink: null,
  },
];

export const TitleRequiredErrors: ErrorNavItem[] = [
  {
    controlId: 'titleServiceControlId',
    controlName: 'Title Service Provider',
    errorText: 'Title Service Co. is required. Please make a selection before continuing.',
    errorLink: null,
  },
];

export const PestRequiredErrors: ErrorNavItem[] = [
  {
    controlId: 'pestServiceControlId',
    controlName: 'Pest Service Provider',
    errorText: 'Pest Service Co. is required. Please make a selection before continuing.',
    errorLink: null,
  },
];

export const SettlementRequiredErrors: ErrorNavItem[] = [
  {
    controlId: 'settlementServiceControlId',
    controlName: 'Settlement Service Provider',
    errorText: 'Settlement Service Co. is required. Please make a selection before continuing.',
    errorLink: null,
  },
];

export const StructuralEngineeringRequiredErrors: ErrorNavItem[] = [
  {
    controlId: 'structuralEngineeringServiceControlId',
    controlName: 'Engineering/Structural Inspections Service Provider',
    errorText: 'Engineering/Structural Inspections Co. is required. Please make a selection before continuing.',
    errorLink: null,
  },
];

// SmartFee Validation Constants
export const SMARTFEES_MAX_SALESPRICE = 20000000.0;

export const getErrorByControlId = (section: string, controlId: string): ErrorNavItem => {
  switch (section) {
    case GetCcwSectionName(FeeWorksheetMilestone.LoanPropertySection):
      return structuredClone(LoanPropertyRequiredErrors.find((e) => e.controlId === controlId));
    case GetCcwSectionName(FeeWorksheetMilestone.LandServiceSection):
      return structuredClone(SurveyRequiredErrors.find((e) => e.controlId === controlId));
    case GetCcwSectionName(FeeWorksheetMilestone.TitleServiceSection):
      return structuredClone(TitleRequiredErrors.find((e) => e.controlId === controlId));
    case GetCcwSectionName(FeeWorksheetMilestone.PestServiceSection):
      return structuredClone(PestRequiredErrors.find((e) => e.controlId === controlId));
    case GetCcwSectionName(FeeWorksheetMilestone.SettlementServiceSection):
      return structuredClone(SettlementRequiredErrors.find((e) => e.controlId === controlId));
    case GetCcwSectionName(FeeWorksheetMilestone.StructuralEngineeringSection):
      return structuredClone(StructuralEngineeringRequiredErrors.find((e) => e.controlId === controlId));
  }
};

export function isEmpty<T>(value: T | null | undefined | ''): value is null | undefined | '' {
  return value === null || value === undefined || value === '';
}

export function isFutureDate(date: Date): boolean {
  if (date === null || date === undefined || date.toString() === '' || date.toString() === '0001-01-01T00:00:00') {
    return false;
  }
  const minDate = new Date();
  minDate.setHours(0, 0, 0, 0);
  date = new Date(date.toString());
  date.setHours(0, 0, 0, 0);
  if (date < minDate) {
    return false;
  }
  return true;
}
